module.exports = __webpack_public_path__ + "img/ptdA.cd14e620.png";